import React, {Component} from 'react';
import { Link } from 'react-router-dom'
//import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

class TestRunStatusTable extends Component{
//    constructor(props){
//            super(props)
//
//    }
//
    render(){
        return(
            <section data-test = 'testRunStatusTableComponent' className="content">
                <div className="container-fluid">
                {this.props.testRunStatus.length > 0 ?
                    <table className="table">
                        <thead>
                            <tr className="table-head">
                                <th scope="col" key="bench_id" style={{ textAlign: "center",verticalAlign: "top"}}>Bench ID</th>
                                <th scope="col" key="bench_name" style={{ textAlign: "center",verticalAlign: "top" }}>Bench Name</th>
                                <th scope="col" key="scheduler_uuid" style={{ textAlign: "center",verticalAlign: "top" }}>Scheduler UUID</th>
                                <th scope="col" key="test_run_id" style={{ textAlign: "center" ,verticalAlign: "top"}}>Test Run ID</th>
                                <th scope="col" key="tag_name" style={{ textAlign: "center",verticalAlign: "top" }}>Version(Tag)</th>
                                <th scope="col" key="time" style={{ textAlign: "center" ,verticalAlign: "top"}}>Time</th>
                                <th scope="col" key="status" style={{ textAlign: "center" ,verticalAlign: "top"}}>Status</th>
                                
                            </tr>
                        </thead>
                          <tbody>
                            {this.props.testRunStatus.map((element, index) =>{
                                return(
                                    <tr key={index} className="table-row">
                                        <td>{element.bench_id}</td>
                                        <td>{element.bench_name}</td>
                                        <td>{element.scheduler_uuid}</td>
                                        <td>{element.test_run_id}</td>
                                        <td>{element.tag_name}</td>
                                        <td>{element.time_update}</td>

                                        {element.status === "validation_completed" ?
                                        <td>
                                        <Link to={{
                                                        pathname :"/camera_dashboard_level3",
                                                        totalData : this.props.testRunStatus[index]
                                                        }}>
                                                {element.status}

                                             </Link>

                                        </td> : <td>{element.status}</td>
                                        }
                                    </tr>
                            )
                            })}
                        </tbody>
                    </table>
                : <div className="alert alert-secondary" role="alert">
                    No data available
                  </div>}

            </div>
        </section>
        )


}
}
TestRunStatusTable.propTypes={
testRunStatus:PropTypes.string,
}
TestRunStatusTable.defaultProps= {
testRunStatus:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default TestRunStatusTable
